import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function ElectricityDeposit() {
  return (
    <section
      id="electricity"
      aria-labelledby="electricity-heading"
      className="bg-background py-16 md:py-20"
    >
      <div className="shell">
        <Reveal>
          <Eyebrow>For Extended Stays</Eyebrow>
        </Reveal>
        <h2 id="electricity-heading" className="display-lg mt-6 max-w-[16ch]">
          <MaskReveal>Electricity &amp; Service Deposit</MaskReveal>
        </h2>

        <div className="mt-10 grid gap-6 lg:grid-cols-2">
          <Reveal>
            <article className="h-full border border-border bg-card p-8 md:p-10">
              <p className="eyebrow text-primary">$250 Service Deposit</p>
              <div className="mt-6 space-y-4 text-base leading-relaxed text-muted-foreground">
                <p>All extended-stay guests are required to provide a $250 service deposit.</p>
                <p>The deposit is applied toward the guest&apos;s final electrical bill.</p>
                <p>Any unused remaining portion is refunded.</p>
              </div>
            </article>
          </Reveal>
          <Reveal delay={0.08}>
            <article className="h-full border border-border bg-card p-8 md:p-10">
              <p className="eyebrow text-primary">Metered Electricity</p>
              <div className="mt-6 space-y-4 text-base leading-relaxed text-muted-foreground">
                <p>Electricity for extended stays is calculated according to actual usage.</p>
                <p>Monthly electrical charges can vary.</p>
                <p>
                  Electricity is not included in the $1,260 starting monthly rate and is billed
                  separately based on use.
                </p>
              </div>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
